import {Component, Input} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {ClassificationField} from "../../models/classification-field";
import {ClassificationGroup} from "../../models/classification-group";
import {Guide} from "../../models/guide";
import {ClassificationControllerService} from "../../services/classifications-controller/classification-controller.service";
import {BaseError} from "../pages/base-error";
import FormUtils from "../utils/form-utils.component";
import { map } from 'rxjs/operators';

@Component({
    selector: "list-group-item",
    templateUrl: "./list-group-item.component.html",
})
export class ListGroupItemComponent extends BaseError {
    @Input() public isEnum: boolean = false;
    @Input() public isActive: boolean = false;
    @Input() public selections: string[] = [];
    @Input() public guide: Guide;
    @Input() public group: ClassificationGroup;
    @Input() public catalogIds: { value: string[] } = {value: []};
    @Input() public showIcon: boolean = false;

    public effectAllowed: string = "all";
    public catalogItems: ClassificationField[] = [];

    constructor(private classificationControllerService: ClassificationControllerService, toastr: ToastrService) {
        super(toastr);
    }

    public showSelections() {
        if (!this.isEnum) { return false; }
        this.isActive = !(this.isActive);

        if (!this.isActive) {
            this.catalogIds.value = [];
            return false;
        }

        this.catalogIds.value = (this.guide.classification) ? [this.guide.classification.id] : [];
        if (!this.catalogIds.value.length && this.guide.classifications && this.guide.classifications.length) {
            this.catalogIds.value = this.guide.classifications.map((classification) => {
                return classification.id;
            });
        }

        const promises = [];

        this.catalogIds.value.forEach((id) => {
            promises.push(
                this.classificationControllerService.getClassificationsByType(id).pipe(map((data) => {
                    return data;
                })).toPromise(),
            );
        });

        Promise.all<any[]>(promises).then((results: any[]) => {
            results.forEach((catalog) => {
                catalog.forEach((classificationField) => {
                    this.catalogItems.push(classificationField);
                });
            });
        });
    }

    public idFromTitle(title) {
        return FormUtils.generateGuideIdFromTitle(title);
    }
}
